import styled from 'styled-components'

export const Stamp = styled.div`
  position: absolute;
  right: 8px;
  bottom: 20px;
  z-index: 1;
  width: 80px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
  background: #2e2d37;
  border-radius: 6px;
  opacity: 0.8;
`
export const StampTestAB = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 1;
  width: 66px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  background: rgba(105, 105, 119, 0.4);

  span {
    font-size: 10px;
    color: #ffffff;
    font-weight: 500;
  }
`
